export interface IBooleanListItem {
    value: boolean;
    text: string;
    selected: boolean;
}